<template>
    <section>
        <div class="card">
            <!-- message of no domains -->
              <div v-if="!accounts.length" class="card-body text-center mb-5 pt-5">
                <h6>There are currently no domains available in the account to provide email service for.  Please <router-link to="/sites/add-site">click here</router-link> to add a domain now.</h6>
            </div>
            <div v-else class="card-body text-center mb-5 pt-5">
                <button type="button" class="btn btn-lg btn-primary" @click="getHostingAccounts()">
                    Setup New Email Service
                </button>
            </div>
            <div class="alert alert-warning alert-with-icon alert-dismissible fade show m-0" data-notify="container">
                <button type="button" aria-hidden="true" class="close" data-dismiss="alert" aria-label="Close">
                    <i class="nc-icon nc-simple-remove"></i>
                </button>
                <span data-notify="icon" class="nc-icon nc-alert-circle-i"></span>
                <span data-notify="message">Please note this will create a new email service with us, giving you the option to create new email accounts. If you are using or wish to use a third party email service such as GSuite or office365, it will not display here. If you currently use a cPanel mail service and wish to migrate your current email account to us, please reach out to our support team for assistance. For any other type of mail service, unfortunately we will be unable to migrate your email history (inbox, outbox, etc) - but you are welcome to create new accounts here!</span>
            </div>
        </div>

        <div class="stepModal lg position-relative">
            <div class="modal fade" id="newEmailModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="twoFAStepModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title text-primary" id="twoFAStepModalHeader">Add New Email Account</h5>
<!--                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
<!--                                <span aria-hidden="true">&times;</span>-->
<!--                            </button>-->
                        </div>
                        <div class="modal-body">
                            <AddNewEmail/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
    import { db } from "@/firebase/init";
    import swal from 'sweetalert2';
    import emailSetupMixin from "../../../mixins/emailSetupMixin";
    export default {
        name: "EmptyEmial",
        mixins: [emailSetupMixin],
        components: {
            AddNewEmail: () =>
                import(/* webpackChunkName: "topNav" */ "./AddNewEmail.vue"),
        },
        computed: {
            asyncDone() {
                return this.$store.getters["async/state"];
            },
            userUId() {
                return this.$store.getters.getUID;
            },
            accounts() {
                return this.$store.getters["hosting/accountsOrdered"];
            },
        },
        methods:{
            closePopup(){
                $("#newEmailModal").modal('hide');
            },
            openPopUp(){
                if(this.alreadyAccountFlag){
                    this.$store.state.emailSetup = true;
                }else{
                    console.log('opening');
                    $('#newEmailModal').modal('show');
                    $('.modal-backdrop').removeClass("modal-backdrop");
                }
            },
        }
    }

</script>

<style scoped>

</style>
